import styled from "styled-components";

export const sharedGap = "8px 22px";

export const StyledEntrantSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${sharedGap};

  [grid-full-width] {
    grid-column: span 2;
  }
`;
StyledEntrantSection.displayName = "StyledEntrantSection";

export const StyledEntrant = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${sharedGap};

  [grid-full-width] {
    grid-column: span 2;
  }
`;
StyledEntrant.displayName = "StyledEntrant";

export const StyledEntrantName = styled.h6`
  border-bottom: 1px solid #d9d9d975;
  font-weight: 500;
  margin: 0;
  padding-bottom: 5px;
  margin-top: 5px;
`;
StyledEntrantName.displayName = "StyledEntrantName";
